<template>
	<div class="content-1">
        <!-- <div class="title-1">
          	<span class="max-text font-family-Semibold"> {{ title }} 
			<span v-if="dataSource.length<10" class="min-text">( 0{{ dataSource.length }})</span>
			<span v-else class="min-text">( {{ dataSource.length }})</span>
			</span>
          	<br />
        </div> -->
        <!-- :type="type === typeWord || type === typePdf ? setTypeFile(item.path) : type" -->
		<DetailButton
			v-for="(item, index) of dataSource"
			:key="index"
			:dataSource="item"
			:path="item.path"
			:pathView="item.pathView"
			:name="item.name"
		/>
   	</div>
</template>

<script>
	import DetailButton from './DetailButton.vue'
	import { mapActions } from 'vuex'
	import { CONTENT_TYPE_VIDEO, CONTENT_TYPE_PDF, CONTENT_TYPE_WORD, CONTENT_TYPE_POWERPOINT } from '@/store/common/constants'
	import { isPdf } from '@/helpers/functions'


	export default {
		name: 'ListFilesButtons',
		props: {
			title: String,
			type: String,
			dataSource: Array
		},
		data() {
			return {
				typeVideo: CONTENT_TYPE_VIDEO,
				typeWord: CONTENT_TYPE_WORD,
				typePdf: CONTENT_TYPE_PDF,
				typePow: CONTENT_TYPE_POWERPOINT
			};
		},
		methods: {
			...mapActions('common', ['toggleModalPreview', 'setDocPreviewContent']),

			setTypeFile(link) {
				return isPdf(link) ? CONTENT_TYPE_PDF : CONTENT_TYPE_WORD;
			},
			previewDoc(data) {
				this.setDocPreviewContent({...data})
				this.toggleModalPreview(true)
			}
		},
		components: {
			DetailButton
		}
	};
</script>

<style lang="scss" scoped>
	.title-1{
		border-bottom: 1px solid #9e9a9a;
		padding-bottom: 10px;
		padding-top:20px;
		.max-text{
			font-size: 24px;
			color: #40505e;
			cursor: pointer;
			.min-text{
				font-size: 14px;
				color: #879AA9;
				cursor: pointer;
				&:hover{
					color: #124ABE;
				}
			}
		}
	}
</style>
